"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateConnectConnectionSchema = exports.ConnectionOptions = exports.ConnectConnectionStatus = void 0;
const zod_1 = __importDefault(require("zod"));
var ConnectConnectionStatus;
(function (ConnectConnectionStatus) {
    ConnectConnectionStatus["Active"] = "ACTIVE";
    ConnectConnectionStatus["Paused"] = "PAUSED";
    ConnectConnectionStatus["Disabled"] = "DISABLED";
})(ConnectConnectionStatus || (exports.ConnectConnectionStatus = ConnectConnectionStatus = {}));
exports.ConnectionOptions = zod_1.default.object({
    sendInteractions: zod_1.default.boolean().optional(),
    filterNonContactUsers: zod_1.default.boolean().optional(),
});
exports.CreateConnectConnectionSchema = zod_1.default.object({
    fromTenantId: zod_1.default.string().uuid(),
    fromCreditorId: zod_1.default.string().uuid().optional(),
    toTenantId: zod_1.default.string().uuid(),
    toCreditorId: zod_1.default.string().uuid(),
    productId: zod_1.default.string().uuid(),
    options: exports.ConnectionOptions.optional(),
});
//# sourceMappingURL=index.js.map